<template>
  <div class="py-2">
    <PanelHeader v-if="title"
      >{{ title }}
      <template #actions>
        <slot name="actions" />
      </template>
    </PanelHeader>
    <slot />
    <PanelFormContent v-if="$slots.content"><slot name="content" /></PanelFormContent>
  </div>
</template>

<script setup>
import { PanelFormContent, PanelHeader } from '@/components';

const props = defineProps({ title: { type: String } });
</script>
